import script from "./moreDevice.vue?vue&type=script&setup=true&lang=js"
export * from "./moreDevice.vue?vue&type=script&setup=true&lang=js"

import "./moreDevice.vue?vue&type=style&index=0&id=22b765a4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22b765a4"]])

export default __exports__